import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/PageHeader";
import { LibroSoci } from "@/components/admin/LibroSoci";
import { QuoteAdmin } from "@/components/admin/QuoteAdmin";
import { Tesserati } from "@/components/admin/Tesserati";
import { AssociazioneAdmin } from "@/components/admin/AssociazioneAdmin";
import { useAuth } from "@/context/AuthContext";
import { ComunicazioniAdmin } from "@/components/admin/ComunicazioniAdmin";
import { NewsAdmin } from "@/components/admin/NewsAdmin";
import { Equipaggi } from "@/components/admin/Equipaggi";
import { RankingAdmin } from "@/components/admin/RankingAdmin";
import { ClassiAdmin } from "@/components/admin/ClassiAdmin";

const TABS = [
  ["soci", "Libro soci", LibroSoci, true],
  ["equipaggi", "Elenco equipaggi", Equipaggi, true],
  ["regate", "Regate e ranking", RankingAdmin, false],
  ["classi", "Classi", ClassiAdmin, false],
  ["comunicazioni", "Comunicazioni", ComunicazioniAdmin, false],
  ["news", "News", NewsAdmin, true],
  ["quote", "Quote associative", QuoteAdmin, false],
  ["tesserati", "Tesserati e ruoli", Tesserati, false],
  ["associazione", "Associazione e privacy", AssociazioneAdmin, false],
];

export default function Admin() {
  const { user } = useAuth();
  const [params, setParams] = useSearchParams();
  const tabs = TABS.filter(([, , , staff]) => staff || user.role === "admin");
  const requested = params.get("tab");
  const tab = tabs.some(([k]) => k === requested) ? requested : "soci";
  return (
    <div>
      <PageHeader kicker="Segreteria" title={user.role === "admin" ? "Amministrazione" : "Gestione"} />
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="mb-6 flex-wrap h-auto">
          {tabs.map(([k, label]) => <TabsTrigger key={k} value={k} data-testid={`admin-tab-${k}`}>{label}</TabsTrigger>)}
        </TabsList>
        {tabs.map(([k, , C]) => <TabsContent key={k} value={k}><C /></TabsContent>)}
      </Tabs>
    </div>
  );
}
